import type {FC} from 'react';
import clsx from 'clsx';

import {Button} from '@/modules/foundation/components/button';
import {Link} from '@/modules/foundation/components/link';

export type NavLinkType = {
	type: 'navlink';
	title: string;
	href: string;
	targetBlank?: boolean;
	featured?: boolean;
};

type NavLinkProps = {
	link: NavLinkType;
	onClick?: () => void;
};

export const NavLink: FC<NavLinkProps> = ({link, onClick}) => {
	if (link.featured) {
		return (
			<Button asChild>
				<Link
					onClick={onClick}
					href={link.href}
					targetBlank={link.targetBlank}
					className={clsx('inline-block')}
				>
					{link.title}
				</Link>
			</Button>
		);
	}

	return (
		<Link
			onClick={onClick}
			href={link.href}
			targetBlank={link.targetBlank}
			className={clsx('inline-block', 'no-underline', 'hover:underline')}
		>
			{link.title}
		</Link>
	);
};
